/* ==========================================================================
   Recently viewed products (browser only).
   theme.recentlyViewed.add(handle) is called on product pages; <recently-viewed>
   renders cards fetched via the product-card-render section.
   ========================================================================== */
(() => {
  const KEY = 'xh-recent-products';
  const MAX = 16;
  const { theme } = window;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  };

  theme.recentlyViewed = {
    all: read,
    add(handle) {
      if (!handle) return;
      try {
        localStorage.setItem(KEY, JSON.stringify([handle, ...read().filter((h) => h !== handle)].slice(0, MAX)));
      } catch {
        /* storage unavailable */
      }
    },
  };

  // Shared card fetcher (also used by wishlist and compare)
  theme.fetchCards =
    theme.fetchCards ||
    (async (handles) => {
      const root = (theme.routes.root || '/').replace(/\/$/, '');
      const results = await Promise.all(
        handles.map(async (handle) => {
          try {
            const res = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=product-card-render`);
            if (!res.ok) return null;
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            return doc.querySelector('.product-card-render product-card');
          } catch {
            return null;
          }
        })
      );
      return results.filter(Boolean);
    });

  if (customElements.get('recently-viewed')) return;
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (window.Shopify?.designMode) return;
        const hasItems = read().some((handle) => handle !== this.dataset.exclude);
        this.hidden = !hasItems;
        if (!hasItems) return;
        // Fetch only when the section approaches the viewport
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            this.load();
          },
          { rootMargin: '400px 0px' }
        );
        observer.observe(this);
      }

      async load() {
        const exclude = this.dataset.exclude;
        const limit = Number(this.dataset.limit) || 8;
        const handles = read().filter((h) => h !== exclude).slice(0, limit);
        if (!handles.length) {
          this.hidden = true;
          return;
        }
        const cards = await theme.fetchCards(handles);
        const track = this.querySelector('[data-recent-track]');
        if (!cards.length || !track) {
          this.hidden = true;
          return;
        }
        track.replaceChildren(
          ...cards.map((card) => {
            const li = document.createElement('li');
            li.className = 'slider__slide';
            li.appendChild(card);
            return li;
          })
        );
        this.hidden = false;
      }
    }
  );
})();
